<template>
  <div class="p_nodes_list">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
              <div class="flname">推送时间</div>
              <el-date-picker
                v-model="sendTime"
                type="daterange" size="small"
                value-format="yyyy-MM-dd"
                range-separator="至" :clearable="false"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
          </div>
          <div class="screenInput">
              <div class="flname">手机号码</div>
              <el-input v-model="listQuery.mobile" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
              <div class="flname">推送结果</div>
              <el-select v-model="listQuery.SendResult" clearable size="small" placeholder="">
                <el-option :value="1" :label="'成功'"></el-option>
                <el-option :value="0" :label="'失败'"></el-option>
              </el-select>
              <el-button size="small" class="n_btn" type="primary" @click="searchHandle">搜索</el-button>
          </div>
        </div>
      </div>
      <!-- <div class="top-right">
        <el-button type="text" @click="dropDownScreen" style="margin-right:20px">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div> -->
      <!-- 筛选下拉框 -->
      <!-- <div class="dropDownScreen" v-show="showDropScreen==1">
        <div  class="inputs">
          <div class="formScreenInput" v-if="isActive==0">
            <div>导入名称</div>
            <el-input size="small" v-model="infoQuery.strobjname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="formScreenInput" v-if="isActive!=0">
            <div>导入名称</div>
            <el-input size="small" v-model="expQuery.custname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="timeip formScreenInput">
            <div>操作时间</div>
            <el-date-picker style="width:300px!important" v-model="infoQuery.impdate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div> -->
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>雇员</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/signupList' }">面试入职流程</el-breadcrumb-item>
                <el-breadcrumb-item>消息通知记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="ftabs">
          <ResourceComTabs ref="child" :active="activeName" :btnAuth="permissionLists" @change="currChange($event)"></ResourceComTabs>
        </div>
        <div class="p_note_box">
          <el-table class="re_table" v-loading="listLoading" :data="tableData" style="width:100%">
            <el-table-column align="center" label="序号">
              <template slot-scope="{$index}">
                  <span>{{(Number(listQuery.pageNum) - 1) * Number(listQuery.pageSize) + Number($index) + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="接收人" min-width="80px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.ReceiveName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号" min-width="120px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.ReceiveMobile}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="项目名称" min-width="110px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                  <span>{{row.StrprojectName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="招聘顾问" min-width="110px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                  <span>{{row.StrRecruitname}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作人" min-width="80px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.Username}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送结果" min-width="100px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                  <span v-if="row.SendResult == '1'">发送成功</span>
                  <span v-if="row.SendResult == '0'">发送失败</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="推送时间" min-width="120px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{isNull(row.SendTime)?'':row.SendTime.replace('T',' ')}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送消息" min-width="300px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                  <span>{{row.TemplateCont}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNum"
            :page-size="listQuery.pageSize"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
        </div>
    </div>
  </div>
</template>

<script>
import xz from "../../common";
import moment from 'moment'
import ResourceComTabs from "./components/resourceComTabs.vue"
export default {
  name: "divideList",
  components: {
    ResourceComTabs
  },
  data() {
    return {
        sendTime:[],
        listLoading:false,
        tableData:[],
        //下拉筛选
        showDropScreen: -1,
        listQuery: {
            pageSize: 10,
            pageNum: 1,
            mobile: '',
            strprojectName:'',
            SendResult:'',//1成功 0失败
            startTime: '',
            endTime: '',
            roletype: localStorage.loginRoletype
        },
        activeName:'',
        roleType: localStorage.loginRoletype,
        total:0,
        // 按钮权限参数
        butQuery: {
          path: '/signupList',
          powerEnName: 'employee'
        },
        permissionLists: [], //按钮权限列表
    }
  },
  created() {
    let endDate = moment().format("YYYY-MM-DD")
    let nowdate = moment().subtract(1,'months').format("YYYY-MM-DD")
    this.listQuery.startTime = nowdate
    this.listQuery.endTime = endDate
    this.sendTime = [nowdate, endDate]
    this.getButtonPower()
    this.getList()
  },
  methods: {
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    // 获取按钮权限
    getButtonPower() {
      let that = this;
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
          } else {
            this.permissionLists = [];
          }
        } else {
          this.permissionLists = [];
        }
      });
    },
    // 子组件传值
    currChange(value) {
      this.$store.commit("setResourceComTabsIsover", false);
      // console.log('currChange',value)
      this.activeName = value
      this.listQuery.pageNum = 1
      this.getList()
    },
    // 搜索
    searchHandle(){
      this.listQuery.pageNum = 1
      if(!this.isNull(this.sendTime)){
        this.listQuery.startTime = this.sendTime[0]
        this.listQuery.endTime = this.sendTime[1]
      }else{
        this.listQuery.startTime = moment().subtract(1,'months').format("YYYY-MM-DD")
        this.listQuery.endTime = moment().format("YYYY-MM-DD")
      }
      this.getList()
    },
    //分页
    handleCurrentChange(val){
        this.listQuery.pageNum = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
        this.listQuery.pageNum = 1
        this.listQuery.pageSize = Number(val)
        this.getList()
    },
    // 获取列表
    getList(){
        this.listLoading = true
        xz.GetNotifyRecord(this.listQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.tableData = res.msg
              this.total = res.totalcount
            }else{
              this.tableData = []
              this.total = 0
            }
            this.listLoading = false
            this.$store.commit("setResourceComTabsIsover", true);
          })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}
</script>


<style scoped>
.ftabs {
  background: #fff;
}
.n_btn{
  margin-left: 10px;
}
.p_note_box{
  padding: 10px 0;
  box-sizing: border-box;
  background-color: #fff;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style>
.el-date-table td.today.end-date span{
  color:#fff!important;
}
.p_nodes_list .screenInput{
  margin: 0 0 10px 10px;
}
.p_nodes_list .screenInput .el-input{
  width: 180px;
}
.p_nodes_list .el-date-editor--daterange.el-input__inner{
  width: 270px!important;
}
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
</style>